import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { buildSlaFiltrarDeadlineMs } from '../utils/slaFiltrarDeadline';
import { SlaFiltrarSingleDateCalendar } from './SlaFiltrarSingleDateCalendar';

function todayYmd() {
  const n = new Date();
  const y = n.getFullYear();
  const m = String(n.getMonth() + 1).padStart(2, '0');
  const d = String(n.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/**
 * Modal centralizado: data (padrão hoje) + horário (hh:mm). Aplicar só com horário válido.
 */
export function BoardFiltrarSLAModal({
  open,
  onClose,
  onApply,
  onClear,
  filterActive
}) {
  const [selectedDate, setSelectedDate] = useState(todayYmd);
  const [timeValue, setTimeValue] = useState('');

  useEffect(() => {
    if (!open) return;
    setSelectedDate(todayYmd());
    setTimeValue('');
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const deadlineMs = buildSlaFiltrarDeadlineMs(selectedDate, timeValue);
  const canApply = deadlineMs != null;

  const handleApply = () => {
    if (!canApply) return;
    onApply({ date: selectedDate, time: timeValue, deadlineMs });
    onClose();
  };

  const handleClear = () => {
    onClear();
    onClose();
  };

  const modal = (
    <div
      className="sla-filtrar-modal-overlay"
      role="presentation"
      onClick={onClose}
    >
      <div
        className="futura-date-filter-modal sla-filtrar-modal-panel"
        role="dialog"
        aria-labelledby="sla-filtrar-title"
        onClick={(e) => e.stopPropagation()}
        style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', right: 'auto', margin: 0 }}
      >
        <div className="futura-date-filter-header">
          <span id="sla-filtrar-title">Filtrar SLA</span>
          <button type="button" className="futura-date-filter-close" onClick={onClose} aria-label="Fechar">
            <i className="bi bi-x"></i>
          </button>
        </div>
        <div className="futura-date-filter-body">
          <SlaFiltrarSingleDateCalendar selectedDate={selectedDate} onSelectDate={setSelectedDate} />
          <div className="futura-date-filter-row sla-filtrar-time-row">
            <label htmlFor="sla-filtrar-time">Horário limite (24h)</label>
            <input
              id="sla-filtrar-time"
              type="time"
              step={60}
              value={timeValue}
              onChange={(e) => setTimeValue(e.target.value)}
              className="sla-filtrar-time-input"
            />
          </div>
          <div className="futura-date-filter-actions sla-filtrar-actions">
            {filterActive && (
              <button type="button" className="futura-date-filter-clear" onClick={handleClear}>
                Limpar filtro
              </button>
            )}
            <button
              type="button"
              className="futura-date-filter-apply"
              onClick={handleApply}
              disabled={!canApply}
            >
              Aplicar
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
}
